<template>
  <div>
    <div v-if="!userLoggedIn">
      <p>You must be logged in to use this page.</p>
    </div>
    <div v-if="userLoggedIn">
      <p>Send a message to the author:</p>
      <p v-if="feedback">{{feedback}}</p>
      <div v-if="sendState === 'sending'">
        <Loader v-bind:size="'large'" />
      </div>
      <div v-if="sendState !== 'sending'">
        <textarea
          class="u-full-width"
          v-model="content"
        ></textarea>
        <button
          class="button"
          @click="send"
        >Send Message</button>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from './Loader'

export default {
  components: { Loader },
  data () {
    return {
      content: '',
      sendState: 'unsent',
      feedback: ''
    }
  },
  computed: {
    userLoggedIn () {
      return this.$store.state.user !== null
    }
  },
  methods: {
    send () {
      this.sendState = 'sending'
      this.$http.post(process.env.API_URL + '/sendemail.php', {
        text: this.content
      }).then(res => {
        if (res.body.status === 'success') {
          this.sendState = 'sent'
          this.content = ''
          this.feedback = res.body.data
        } else {
          this.sendState = 'error'
          this.feedback = res.body.data
        }
      })
    }
  }
}
</script>

<style scoped>
textarea {
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// Email.vue?52867542